import Vue from 'vue'
import Schedio from '@spartanbio/schedio'

Vue.use(Schedio, {
  linkComponent: 'nuxt-link',
})
